import { render, staticRenderFns } from "./CorrectTextAnswerItem.vue?vue&type=template&id=369939ba&scoped=true&"
import script from "./CorrectTextAnswerItem.vue?vue&type=script&lang=ts&"
export * from "./CorrectTextAnswerItem.vue?vue&type=script&lang=ts&"
import style0 from "./CorrectTextAnswerItem.vue?vue&type=style&index=0&id=369939ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369939ba",
  null
  
)

export default component.exports